import { GenericObject } from '../types';

export const createPDPRedirectionUrl = (productId: string, productName: string): string => {
  const charsToRemove = /[<>#%{}^~[\];/?:@=&`\\|!*+'",.]/g;
  const formattedProductName = productName.replace(/\s+/g, '-');
  const filteredProductName = formattedProductName.replace(charsToRemove, '');
  return `/product/${filteredProductName}/${productId}`;
};

export function extractTextFromHTML(html: string) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
}

export function hasRequiredFields<T extends GenericObject, K extends keyof T>(
  obj: T,
  ...keys: K[]
): obj is T & Required<Pick<T, K>> {
  return keys.every((key) => obj[key] !== undefined && obj[key] !== null);
}
